import { render, staticRenderFns } from "./dormitoryTemp.vue?vue&type=template&id=a5538ff2&scoped=true&"
import script from "./dormitoryTemp.vue?vue&type=script&lang=js&"
export * from "./dormitoryTemp.vue?vue&type=script&lang=js&"
import style0 from "./dormitoryTemp.vue?vue&type=style&index=0&id=a5538ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5538ff2",
  null
  
)

export default component.exports